import { combineReducers } from 'redux'
import LangReducer from './lang'

export default combineReducers({
  main: LangReducer
});



// WEBPACK FOOTER //
// ./src/redux/reducer.js